import { render, staticRenderFns } from "./CatalogCategories.vue?vue&type=template&id=6c46c951&scoped=true"
import script from "./CatalogCategories.vue?vue&type=script&lang=js"
export * from "./CatalogCategories.vue?vue&type=script&lang=js"
import style0 from "./CatalogCategories.vue?vue&type=style&index=0&id=6c46c951&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c46c951",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VAutocomplete,VBtn,VContainer,VIcon,VLazy,VListItem,VListItemTitle,VSubheader})
